<template>
  <div class="myCenter modelPage formStyle" style="position: relative;">
    <navbar :nav="nav"></navbar>
    <div>
      <!-- <div class="loginForm mtop10">
        <van-form class="loginFormBox">
          <div>パスワード</div>
          <div class="userInfoItems">
            <van-field v-model="pwd" type="password" readonly />
            <div class="edit" @click="$router.push({ path: `/password` })">
              <img class="icon" src="../../assets/img/icon/icon_edit.png" />
            </div>
          </div>
        </van-form>
      </div> -->

      <div class="loginForm cellListStyle setUpBox" style="margin-top: 0;">
        <van-cell
          title="チュートリアル"
          is-link
          @click="$router.push({ path: `/question` })"
        />
        <van-cell
          title="ご意見・ご要望"
          is-link
          @click="$router.push({ path: `/feedback` })"
        />
        <van-cell
          title="利用規約、著作権、およびプライバシーポリシー"
          is-link
          @click="$router.push({ path: `/userAgreement` })"
        />
      </div>
    </div>
    <div class="copyright">© Smart Sketcher AI</div>
  </div>
</template>

<script>
import navbar from "../../components/navbar/index.vue";
export default {
  components: {
    navbar
  },

  data() {
    return {
      nav: {
        back: true,
        title: "サポート",
        chat: false
      },
      pwd: "123456"
    };
  },
  methods: {
    // goeditUserPwd() {}
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style src="@/assets/css/form.css" scoped></style>
<style>
.myCenter.formStyle .loginForm.cellListStyle.setUpBox .van-cell {
  width: 100%;
}
.myCenter.formStyle .loginForm.cellListStyle.setUpBox .van-cell span {
  max-width: 78%;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
}
.myCenter.formStyle .copyright{
  font-size: 14px;
  font-family: MediumFont;
  text-align: center;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 10px;
}
@media screen and (min-width: 1439px) {
  .myCenter.formStyle .loginForm.cellListStyle.setUpBox .van-cell span {
    height: 30px; /* no*/
  }
.myCenter.formStyle .copyright{
  font-size: 14px; /* no*/
  bottom: 10px; /* no*/
}
}
</style>



// WEBPACK FOOTER //
// src/pages/myCenter/setUp.vue